// extracted by mini-css-extract-plugin
export default {"main":"subProduct_main__Kx3JE","topImg":"subProduct_topImg__nZ+l3","main1":"subProduct_main1__dTIEx","heart":"subProduct_heart__7BfKg","singleItem":"subProduct_singleItem__DGR77"};